module.exports = __webpack_public_path__ + "static/media/share.0e77c4ef.svg";